const background = ({ errorColorPalette }) => errorColorPalette[400];

export default background;
